/**
 * @file 管理の操作担当者編集画面で操作担当者を選択したときのカスタムイベントリスナー
 */
'use strict'

/**
 * @classname BtnCommonMemberSearchSelectedListener
 * @classdesc 管理の操作担当者編集画面で操作担当者を選択したときのカスタムイベントリスナー
 */
export default class BtnCommonMemberSearchSelectedListener {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('#modal-common-member-search[data-custom-event-name="saj.selected"')
	 */
	constructor($e, controller) {
		console.log(`BtnCommonMemberSearchSelectedListener.constructor`)
		this._$e = $e
		this._controller = controller
		this._screenName = this._$e.data('screen-name')
		this._element = document.getElementById('modal-common-member-search')
		this._element.addEventListener('saj.selected', event => this.onCustomEvent(event))
	}


	/**
	 * カスタムイベントコールバック
	 *
	 * @memberof BtnCommonMemberSearchSelectedListener
	 * @return {undefined}
	 */
	onCustomEvent(event) {
		console.log(`BtnCommonMemberSearchSelectedListener.onCustomEvent`)
		console.log(event.detail.data)
		switch (this._screenName) {
			case 'administrational-operator':
			case 'general-operator':
				{
					console.log(`BtnCommonMemberSearchSelectedListener.onCustomEvent / screenName: ${this._screenName}`)
					const $dummyTarget = $(`.selected-member-id-dummy[data-index="${this._$e.attr('data-current-index')}"]`)
					const dummyTargetResponseNames = $dummyTarget.data('response-name').split(':')
					$dummyTarget.val(`${event.detail.data[dummyTargetResponseNames[0]]} ${event.detail.data[dummyTargetResponseNames[1]]}（${event.detail.data[dummyTargetResponseNames[2]]}）`).trigger('blur')
					const $target = $(`.selected-member-id[data-index="${this._$e.attr('data-current-index')}"]`)
					const targetResponseName = $target.data('response-name')
					$target.val(event.detail.data[targetResponseName])
				}
				break
			case 'contributor':
				{
					console.log(`BtnCommonMemberSearchSelectedListener.onCustomEvent / screenName: ${this._screenName}`)
					$('#contributor-information-wrap').find('[data-response-name]').each((_, element) => {
						$(element).val(event.detail.data[$(element).data('response-name')] ?? '').prop('readonly', true)
					})

				}
				break
			default:
				console.log(`BtnCommonMemberSearchSelectedListener.onCustomEvent / screenName: ${this._screenName}`)
				console.log(`'this._screenName' is invalid`)
				break
		}
	}
}
